"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterContext = exports.FilterContextProvider = exports.FilterContext = void 0;
var react_1 = __importStar(require("react"));
exports.FilterContext = (0, react_1.createContext)(null);
var FilterContextProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(false), isEnabled = _b[0], setIsEnabled = _b[1];
    var contextValue = (0, react_1.useMemo)(function () { return ({
        isEnabled: isEnabled,
        disable: function () { return setIsEnabled(false); },
        enable: function () { return setIsEnabled(true); },
    }); }, [isEnabled]);
    return (react_1.default.createElement(exports.FilterContext.Provider, { value: contextValue }, children));
};
exports.FilterContextProvider = FilterContextProvider;
var useFilterContext = function () {
    var context = (0, react_1.useContext)(exports.FilterContext);
    if (!context) {
        throw new Error("useFilterContext must be used within a FilterContextProvider");
    }
    return context;
};
exports.useFilterContext = useFilterContext;
